import type { ThesisSpiel } from "./types";

export const thesis: ThesisSpiel = {
  oneLiner: "A lean product team built for fast-moving, adaptive products.",
  paragraphs: [
    "As cheeky as we sound, we're actually well versed in the boring-but-important parts of software delivery: Scrum, structured SDLC, TDD, CI/CD, observability, and reliable release processes.",

    "We use AI on top of our already strong software development foundations to keep the team lean, productive, and current — giving you more output without the overhead of a huge delivery team.",

    "We bring experience from real production products — paying subscribers, customer complaints, urgent fixes, changing requirements, failed payments, and hard product pivots included.",
  ],
};
